import { addMilliseconds } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';

const getDateUtilsConfig = () => {
    return Object.assign(Object.assign({}, getDateTimeConfig()), dateTimeUtilFormats[getDateTimeConfig().timeFormat]);
};
const dateTimeUtilFormats = {
    '12hr': {
        dateFormat: 'dd/MM/yyyy',
        dateTimeFormat: 'dd/MM/yyyy hh:mm aa',
        dateTimeFormatWithSeconds: 'dd/MM/yyyy HH:mm:ss aa',
        datePickerMask: '99/99/9999',
        dateTimePickerMaskDate: '99/99/9999 99:99 aa',
        timePickerMaskDate: '99:99 aa',
        monthPickerMaskDate: '99/9999',
        yearPickerMaskDate: '9999',
        datePickerPlaceholder: '  /  /     ',
        dateTimePickerPlaceholder: '  /  /       :   AM',
        timePickerPlaceholder: '  :   AM',
        monthPickerPlaceholder: '  /     ',
    },
    '24hr': {
        dateFormat: 'dd/MM/yyyy',
        dateTimeFormat: 'dd/MM/yyyy HH:mm',
        dateTimeFormatWithSeconds: 'dd/MM/yyyy HH:mm:ss',
        datePickerMask: '99/99/9999',
        dateTimePickerMaskDate: '99/99/9999 99:99',
        timePickerMaskDate: '99:99',
        monthPickerMaskDate: '99/9999',
        yearPickerMaskDate: '9999',
        datePickerPlaceholder: '  /  /     ',
        dateTimePickerPlaceholder: '  /  /       :  ',
        timePickerPlaceholder: '  :  ',
        monthPickerPlaceholder: '  /     ',
    },
};
const dateDefaults = {
    isoFormat: 'utc',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeFormat: '24hr',
    systemTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: 'en',
};
const getDateTimeConfig = () => {
    var _a;
    return (_a = globalThis.dateTimeConfig) !== null && _a !== void 0 ? _a : dateDefaults;
};
const getDefaultFormats = () => ({
    defaultFormats: dateTimeUtilFormats[getDateTimeConfig().timeFormat],
    timezone: getDateTimeConfig().timezone,
    isoFormat: getDateTimeConfig().isoFormat,
});
const convertZonedDateToSystemDate = (zonedDate) => {
    const systemOffsetMs = getTimezoneOffset(getDateTimeConfig().systemTimezone, zonedDate);
    const offsetMs = getTimezoneOffset(getDateTimeConfig().timezone, zonedDate);
    return addMilliseconds(zonedDate, offsetMs - systemOffsetMs);
};
const convertSystemDateToZonedDate = (systemDate) => {
    const systemOffsetMs = getTimezoneOffset(getDateTimeConfig().systemTimezone, systemDate);
    const offsetMs = getTimezoneOffset(getDateTimeConfig().timezone, systemDate);
    return addMilliseconds(systemDate, systemOffsetMs - offsetMs);
};

export { convertSystemDateToZonedDate, convertZonedDateToSystemDate, getDateTimeConfig, getDateUtilsConfig, getDefaultFormats };
